import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { Loader, UnstyledButton, Box, Text, Grid } from "@mantine/core";
import { Link } from "react-router-dom";

import entityColor from "@util/entityColor";
import { Item as BulkCommunicationItem } from "@components/BulkCommunication/BulkCommunicationList";

export default function UserGroupUseList({ userGroupId, useItems = [] }) {
  // const {
  //   data: useItems = [],
  //   isLoading,
  //   isFetching,
  //   error,
  // } = useQuery({
  //   queryKey: ["user-group-use", userGroupId],
  //   queryFn: async () => {
  //     try {
  //       const { data } = await axios.get(`/user-groups/${userGroupId}/`);
  //       return mockUseItems;
  //       return data.response;
  //     } catch (err) {
  //       throw err;
  //     }
  //   },
  //   retry: 1,
  //   retryDelay: 1000,
  // });

  const isLoading = false;
  const isFetching = false;

  return (
    <div
      style={
        {
          // maxHeight: "1000px",
          // overflowY: "auto",
        }
      }
    >
      {isLoading || (isFetching && <Loader />)}
      {!isLoading && !isFetching && useItems.length === 0 && (
        <Text size="sm">Nowhere yet</Text>
      )}
      {useItems.length > 0 && (
        <Grid>
          {useItems.map((use) => (
            <Grid.Col span={{ base: 12, md: 12 }} key={use.id}>
              <BulkCommunicationItem
                original={{
                  ...use,
                  title: use.name,
                  link_url: `/bulk-communication/${use.id}`,
                }}
                colorBackground
              />
            </Grid.Col>
          ))}
        </Grid>
      )}
    </div>
  );
}
